import React, { useEffect, useState } from "react";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import InfoIcon from "@material-ui/icons/Info";
import Navbar from "components/Navbar";
import RefreshIcon from "@material-ui/icons/Refresh";
import WatchLaterIcon from "@material-ui/icons/WatchLater";

import { ContentWrapper } from "components/ContentWrapper";
import { GetIDNowInfo } from "common/graphql/queryDescriptors";
import { StoreState } from "common/store/types";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { User } from "common/store/user/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Box, Grid, Typography, Card, Button } from "@material-ui/core";

import "./IDNowStatus.scss";

const IDVisual = () => (
  <Box className="id-visual">
    <CheckCircleIcon className="icon" />

    <Grid container>
      <Grid item xs={6} className="account-container">
        <AccountCircleIcon className="account" />
      </Grid>

      <Grid
        item
        xs={6}
        container
        className="lines-container"
        direction="column"
        spacing={1}
      >
        <Grid item className="line-wrapper">
          <div className="line--short" />
        </Grid>

        <Grid item className="line-wrapper">
          <div className="line" />
        </Grid>

        <Grid item className="line-wrapper">
          <div className="line" />
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

const IDNowStatusContent = ({ status }: any) => {
  //State
  const [buttonPressed, setButtonPressed] = useState(false);

  //Hooks
  const { t } = useTranslation();
  const storageUserDetails = useSelector<StoreState, User>(
    (state) => state.currentUser
  );

  //Helpers
  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  //Options
  let title = null;
  let subtitle = null;
  let buttonText = null;
  let icon = null;
  let onClick = () => {};

  switch (status) {
    case "NEEDS_APPROVAL":
      icon = <WatchLaterIcon className="icon--big" />;
      title = t(`Information Needs Approval`);
      subtitle = t(`Please wait for your information to be verified.`);
      break;
    case "CREATED":
      title = t(`Verify with IDNow`);
      subtitle =
        t(`Your identification code is`) + ": " + storageUserDetails.idNowId;
      icon = <IDVisual />;
      buttonText = buttonPressed ? <RefreshIcon /> : t("Start");
      onClick = buttonPressed
        ? () => window.location.reload()
        : () => {
            setButtonPressed(true);
            openInNewTab(
              `https://go.test.idnow.de/finpro/identifications/${storageUserDetails.idNowTransactionId}`
            );
          };
      break;
    case "SUCCESS":
      icon = <CheckCircleIcon className="icon--big" />;
      title = t(`Verification Completed`);
      subtitle = t(
        `Thanks for completing verification. You’ll receive an email soon with your results and next steps.`
      );
      break;
    case "SUCCESS_DATA_CHANGED":
      return <></>;
    case "FRAUD_SUSPICION_CONFIRMED":
      icon = <InfoIcon className="icon--big" />;
      title = t(`More Information Needed`);
      subtitle = t(`Please contact FinPro support to be verified.`);
      break;
    default:
      return <></>;
  }

  return (
    <Box className={status !== "CREATED" ? "grid" : ""}>
      {icon}

      <Typography className="status-action-text">{title}</Typography>

      <Typography className="subtitle--centered">{subtitle}</Typography>

      {status === "CREATED" && (
        <Button className="primary" onClick={onClick} variant="contained">
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export const IDNowStatus = () => {
  //Hooks
  const storageUserDetails = useSelector<StoreState, User>(
    (state) => state.currentUser
  );
  const { execute: getIDNowInfo } = useCustomQuery(GetIDNowInfo);

  //Actions
  useEffect(() => {
    getIDNowInfo();
  }, [getIDNowInfo]);

  return (
    <Box>
      <Navbar />

      <ContentWrapper>
        <Box className="idnow-status">
          <Card className={"card"}>
            <IDNowStatusContent status={storageUserDetails.idNowStatus} />
          </Card>
        </Box>
      </ContentWrapper>
    </Box>
  );
};
